import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config.js';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL + 'import-export';

export default {
  getInventoryExport(token) {
    return Axios.get(`${RESOURCE_NAME}/export-inventory`);
  },
   getProductsExport(data,token,config={}) {
    return Axios.post(`${RESOURCE_NAME}/export-products`,data,config);
  },
  getPricesExport(data,token) {
    return Axios.post(`${RESOURCE_NAME}/export-prices`,data);
  },
  postInventoryImport(data,token) {
    const headers = { "Content-Type": "multipart/form-data" };
    return Axios.post(`${RESOURCE_NAME}/import-inventory`,data, {
      headers,
    });
  },
  postPricesImport(data,token) {
    const headers = { "Content-Type": "multipart/form-data" };
    return Axios.post(`${RESOURCE_NAME}/import-prices`,data, {
      headers,
    });
  },
  postProductsImport(data,token) {
    const headers = { "Content-Type": "multipart/form-data" };
    return Axios.post(RESOURCE_NAME + "/import-products", data, {
      headers,
    });
  },
  postReviewColumns(data,token) {
    return Axios.post(`${RESOURCE_NAME}/import-review`,data);
  },
  postConfirmItemImport(data,token) {
    return Axios.post(`${RESOURCE_NAME}/import-confirm`,data);
  },
  getCustomersExport(token) {
    return Axios.get(`${RESOURCE_NAME}/export-customers`);
  },
  postCustomersImport(data) {
    const headers = { "Content-Type": "multipart/form-data" };
    return Axios.post(RESOURCE_NAME + "/import-customers", data, {
      headers,
    });
  },
  postReviewCustomerColumns(data,token) {
    return Axios.post(`${RESOURCE_NAME}/import-customers-review`,data);
  },
  postConfirmCustomerImport(data,token) {
    return Axios.post(`${RESOURCE_NAME}/import-customers-confirm`,data);
  },
  getDropDownsDataOrdersExport(token) {
    return Axios.get(`${RESOURCE_NAME}/export-orders-dropdown-data`);
  },
  getOrdersExportData(data,token) {
    return Axios.post(`${RESOURCE_NAME}/export-orders`,data);
  },
  postReviewStatus(data,token) {
    return Axios.post(`${RESOURCE_NAME}/review-status`,data);
  },
  postReviewCustomerStatus(data,token) {
    return Axios.post(`${RESOURCE_NAME}/review-customers-status`,data);
  }
};
